import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import LoadingButton from "../LoadingButton/LoadingButton";

const CustomAlertDialog = ({
  title,
  open,
  description,
  isLoading,
  proceed,
  handleClose,
  disabled,
}) => {
  return (
    <React.Fragment>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {description}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <LoadingButton
            disabled={disabled}
            isLoading={isLoading}
            onClick={proceed}
            autoFocus
          >
            Agree
          </LoadingButton>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};
export default CustomAlertDialog;
